import { useLanguage } from '../utils/LanguageContext';
import translations from './AccountSettings/AccountSettings.lang.json';
import { ItemView } from './common/CommonComponents';
import { BeneficiaryRelationship, BeneficiaryType } from '../shared/constants/userConstants.js';
import { useAuth } from '../utils/AuthContext.js';
import { formatName } from './common/util.js';

const BeneficiariesView = () => {
  const { lang, langForEnum } = useLanguage(translations);
  const { user } = useAuth();

  const beneficiaryToItem = (beneficiary) => [
    {
      field: 'name',
      value: formatName(beneficiary.name),
    },
    {
      field: 'birthday',
      value: beneficiary.birthday,
    },
    {
      field: 'beneficiaryRelationship',
      value: langForEnum(BeneficiaryRelationship, beneficiary.relationship),
    },
    {
      field: 'beneficiaryType',
      value: langForEnum(BeneficiaryType, beneficiary.type),
    },
    {
      field: 'beneficiarySharePct',
      value: beneficiary.sharePct,
    },
  ];

  return (
    <div>
      <h3>{lang('beneficiaries')}</h3>
      {(user.beneficiaries ?? []).length > 0 ? (
        user.beneficiaries.map((beneficiary, index) => <ItemView key={index} items={beneficiaryToItem(beneficiary)} />)
      ) : (
        <p>{lang('noBeneficiariesRecords')}</p>
      )}
    </div>
  );
};

export default BeneficiariesView;
